import { LandingPage } from '@modules/landing';

export default function Landing() {
  return <LandingPage />;
}
